import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import PageHero from '../components/PageHero';

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.publicPage(slug)
      .then((p) => {
        setPage(p);
        if (p?.meta_title) document.title = `${p.meta_title} | YEKÜV`;
        else if (p?.title) document.title = `${p.title} | YEKÜV`;
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <section className="bg-cream py-24 text-center px-6">
      <div className="max-w-md mx-auto">
        <div className="text-[11px] tracking-[0.3em] uppercase text-coral-300 font-semibold">404</div>
        <h1 className="font-display text-4xl md:text-5xl text-ink-600 mt-4">Sayfa bulunamadı</h1>
        <p className="text-ink-500 mt-4 text-sm">Aradığınız sayfa yayından kaldırılmış veya URL yanlış olabilir.</p>
      </div>
    </section>
  );

  if (!page) return (
    <section className="bg-cream min-h-[40vh] grid place-items-center">
      <div className="text-ink-400 text-sm">Yükleniyor…</div>
    </section>
  );

  return (
    <>
      <section className="relative bg-ink-600 text-cream overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(circle at 30% 30%, #C9A96E 0, transparent 55%)' }} />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-24 md:py-28">
          <div className="text-[11px] tracking-[0.3em] uppercase text-gold font-semibold">Sayfa</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.98] mt-5 max-w-4xl" data-testid="custom-page-title">{page.title}</h1>
        </div>
      </section>
      <section className="bg-cream">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 md:py-24">
          <div className="prose-yekuv" data-testid="custom-page-content" dangerouslySetInnerHTML={{ __html: page.content_html || '' }} />
        </div>
      </section>
    </>
  );
}
